import {EmptyObject} from "../common-types";
import {LanguageCodes, languageIsRtl} from "../lang-utils/lang-utils";

type ShouldNotTranslateAttributes = {
    translate: 'no'
}

export function htmlShouldNotTranslate () : ShouldNotTranslateAttributes;
export function htmlShouldNotTranslate (shouldNotTranslate: true) : ShouldNotTranslateAttributes;
export function htmlShouldNotTranslate (shouldNotTranslate: false) : EmptyObject;
export function htmlShouldNotTranslate (shouldNotTranslate: boolean) : ShouldNotTranslateAttributes | EmptyObject;
export function htmlShouldNotTranslate (shouldNotTranslate = true) : ShouldNotTranslateAttributes | EmptyObject {

    if (shouldNotTranslate) {
        return {
            translate: 'no'
        } as const
    } else {
        return {}
    }
}

export const HtmlForcedLocaleAttributeName = 'data-html-forced-locale';

export function htmlForceLocale (lang: LanguageCodes, disabled = false) {
    if (disabled) {
        return {};
    } else {
        return {
            [HtmlForcedLocaleAttributeName]: 'true',
            lang: lang,
            dir: languageIsRtl(lang) ? 'rtl' : 'ltr'
        }
    }
}

export function htmlForceEnglishLocale (disabled = false) {
    return htmlForceLocale(LanguageCodes.English, disabled);
}

const SameOriginIframeMarkingAttributeName = 'data-same-origin-iframe';

export function htmlSameOriginIframeCreateMarking () {
    return {
        [SameOriginIframeMarkingAttributeName]: 'true'
    }
}

export function htmlSameOriginIframeCreateSelector () {
    return `[${SameOriginIframeMarkingAttributeName}]`
}